/**
 * World Conquest data definitions
 * 10 countries with 3 facilities each
 */

export interface FacilityDef {
  nameKey: string;
  descKey: string;
  baseCost: number;
  effectType: 'cps_pct' | 'tap_pct' | 'offline_pct' | 'gc_pct' | 'golden_pct' | 'producer_discount';
  effectPerLevel: number;
}

export interface CountryDef {
  id: string;
  nameKey: string;
  descKey: string;
  conquestCost: number;
  order: number;
  flag: string;
  facilities: [FacilityDef, FacilityDef, FacilityDef];
}

export const COUNTRIES: CountryDef[] = [
  {
    id: 'egypt', nameKey: 'cq_egypt', descKey: 'cq_egypt_desc',
    conquestCost: 3_000, order: 1, flag: '\u{1F1EA}\u{1F1EC}',
    facilities: [
      { nameKey: 'fac_pyramid_vault', descKey: 'fac_pyramid_vault_d', baseCost: 1_000_000, effectType: 'cps_pct', effectPerLevel: 5 },
      { nameKey: 'fac_nile_network', descKey: 'fac_nile_network_d', baseCost: 2_000_000, effectType: 'offline_pct', effectPerLevel: 5 },
      { nameKey: 'fac_ancient_lab', descKey: 'fac_ancient_lab_d', baseCost: 3_000_000, effectType: 'tap_pct', effectPerLevel: 10 },
    ],
  },
  {
    id: 'brazil', nameKey: 'cq_brazil', descKey: 'cq_brazil_desc',
    conquestCost: 20_000, order: 2, flag: '\u{1F1E7}\u{1F1F7}',
    facilities: [
      { nameKey: 'fac_amazon_hideout', descKey: 'fac_amazon_hideout_d', baseCost: 10_000_000, effectType: 'producer_discount', effectPerLevel: 2 },
      { nameKey: 'fac_samba_broadcast', descKey: 'fac_samba_broadcast_d', baseCost: 15_000_000, effectType: 'cps_pct', effectPerLevel: 8 },
      { nameKey: 'fac_jungle_lab', descKey: 'fac_jungle_lab_d', baseCost: 20_000_000, effectType: 'golden_pct', effectPerLevel: 5 },
    ],
  },
  {
    id: 'india', nameKey: 'cq_india', descKey: 'cq_india_desc',
    conquestCost: 150_000, order: 3, flag: '\u{1F1EE}\u{1F1F3}',
    facilities: [
      { nameKey: 'fac_naga_temple', descKey: 'fac_naga_temple_d', baseCost: 100_000_000, effectType: 'gc_pct', effectPerLevel: 5 },
      { nameKey: 'fac_bollywood_studio', descKey: 'fac_bollywood_studio_d', baseCost: 150_000_000, effectType: 'offline_pct', effectPerLevel: 8 },
      { nameKey: 'fac_caste_network', descKey: 'fac_caste_network_d', baseCost: 200_000_000, effectType: 'cps_pct', effectPerLevel: 12 },
    ],
  },
  {
    id: 'australia', nameKey: 'cq_australia', descKey: 'cq_australia_desc',
    conquestCost: 1_000_000, order: 4, flag: '\u{1F1E6}\u{1F1FA}',
    facilities: [
      { nameKey: 'fac_desert_bunker', descKey: 'fac_desert_bunker_d', baseCost: 1_000_000_000, effectType: 'tap_pct', effectPerLevel: 15 },
      { nameKey: 'fac_ayers_signal', descKey: 'fac_ayers_signal_d', baseCost: 1_500_000_000, effectType: 'golden_pct', effectPerLevel: 8 },
      { nameKey: 'fac_outback_base', descKey: 'fac_outback_base_d', baseCost: 2_000_000_000, effectType: 'cps_pct', effectPerLevel: 15 },
    ],
  },
  {
    id: 'japan', nameKey: 'cq_japan', descKey: 'cq_japan_desc',
    conquestCost: 10_000_000, order: 5, flag: '\u{1F1EF}\u{1F1F5}',
    facilities: [
      { nameKey: 'fac_akiba_ai', descKey: 'fac_akiba_ai_d', baseCost: 10_000_000_000, effectType: 'cps_pct', effectPerLevel: 20 },
      { nameKey: 'fac_ninja_intel', descKey: 'fac_ninja_intel_d', baseCost: 15_000_000_000, effectType: 'producer_discount', effectPerLevel: 3 },
      { nameKey: 'fac_tokyo_tower', descKey: 'fac_tokyo_tower_d', baseCost: 20_000_000_000, effectType: 'gc_pct', effectPerLevel: 8 },
    ],
  },
  {
    id: 'korea', nameKey: 'cq_korea', descKey: 'cq_korea_desc',
    conquestCost: 100_000_000, order: 6, flag: '\u{1F1F0}\u{1F1F7}',
    facilities: [
      { nameKey: 'fac_gangnam_hq', descKey: 'fac_gangnam_hq_d', baseCost: 100_000_000_000, effectType: 'cps_pct', effectPerLevel: 25 },
      { nameKey: 'fac_cyber_command', descKey: 'fac_cyber_command_d', baseCost: 150_000_000_000, effectType: 'tap_pct', effectPerLevel: 25 },
      { nameKey: 'fac_kpop_brainwash', descKey: 'fac_kpop_brainwash_d', baseCost: 200_000_000_000, effectType: 'gc_pct', effectPerLevel: 10 },
    ],
  },
  {
    id: 'uk', nameKey: 'cq_uk', descKey: 'cq_uk_desc',
    conquestCost: 1_000_000_000, order: 7, flag: '\u{1F1EC}\u{1F1E7}',
    facilities: [
      { nameKey: 'fac_royal_infiltrate', descKey: 'fac_royal_infiltrate_d', baseCost: 1_000_000_000_000, effectType: 'cps_pct', effectPerLevel: 30 },
      { nameKey: 'fac_london_tower', descKey: 'fac_london_tower_d', baseCost: 1_500_000_000_000, effectType: 'offline_pct', effectPerLevel: 15 },
      { nameKey: 'fac_mi6_double', descKey: 'fac_mi6_double_d', baseCost: 2_000_000_000_000, effectType: 'golden_pct', effectPerLevel: 12 },
    ],
  },
  {
    id: 'russia', nameKey: 'cq_russia', descKey: 'cq_russia_desc',
    conquestCost: 10_000_000_000, order: 8, flag: '\u{1F1F7}\u{1F1FA}',
    facilities: [
      { nameKey: 'fac_siberia_base', descKey: 'fac_siberia_base_d', baseCost: 10_000_000_000_000, effectType: 'cps_pct', effectPerLevel: 40 },
      { nameKey: 'fac_kgb_remnant', descKey: 'fac_kgb_remnant_d', baseCost: 15_000_000_000_000, effectType: 'producer_discount', effectPerLevel: 5 },
      { nameKey: 'fac_nuke_bunker', descKey: 'fac_nuke_bunker_d', baseCost: 20_000_000_000_000, effectType: 'tap_pct', effectPerLevel: 40 },
    ],
  },
  {
    id: 'china', nameKey: 'cq_china', descKey: 'cq_china_desc',
    conquestCost: 100_000_000_000, order: 9, flag: '\u{1F1E8}\u{1F1F3}',
    facilities: [
      { nameKey: 'fac_great_wall', descKey: 'fac_great_wall_d', baseCost: 100_000_000_000_000, effectType: 'cps_pct', effectPerLevel: 50 },
      { nameKey: 'fac_shenzhen_factory', descKey: 'fac_shenzhen_factory_d', baseCost: 150_000_000_000_000, effectType: 'producer_discount', effectPerLevel: 8 },
      { nameKey: 'fac_panda_spy', descKey: 'fac_panda_spy_d', baseCost: 200_000_000_000_000, effectType: 'golden_pct', effectPerLevel: 20 },
    ],
  },
  {
    id: 'usa', nameKey: 'cq_usa', descKey: 'cq_usa_desc',
    conquestCost: 1_000_000_000_000, order: 10, flag: '\u{1F1FA}\u{1F1F8}',
    facilities: [
      { nameKey: 'fac_area51', descKey: 'fac_area51_d', baseCost: 1_000_000_000_000_000, effectType: 'cps_pct', effectPerLevel: 80 },
      { nameKey: 'fac_pentagon', descKey: 'fac_pentagon_d', baseCost: 1_500_000_000_000_000, effectType: 'tap_pct', effectPerLevel: 80 },
      { nameKey: 'fac_wall_street', descKey: 'fac_wall_street_d', baseCost: 2_000_000_000_000_000, effectType: 'gc_pct', effectPerLevel: 25 },
    ],
  },
];

/** Get facility upgrade cost: baseCost * 1.5^level */
export function getFacilityCost(baseCost: number, currentLevel: number): number {
  if (currentLevel === 0) return baseCost;
  return Math.floor(baseCost * Math.pow(1.5, currentLevel));
}
